import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontIcon } from '@fluentui/react';
import { Glyphicon } from '@bingads-webui-react/primitive';
import _ from 'underscore';

export const SelectableCard = (props) => {
  const {
    id,
    title,
    description,
    descriptionValue,
    selected,
    onClickCard,
    classes,
    iconName,
    glyphIconName,
    isDisabled,
    useLargeCards,
    ariaItemSize,
    ariaItemIndex,
    footer,
    name,
  } = props;
  const onClickHandler = useCallback(() => onClickCard(id), [onClickCard, id]);

  const ariaLable = useMemo(() => (_.isString(description) ? `${title} ${description}` : `${title} ${descriptionValue}`), [description, title, descriptionValue]);

  return (
    <div
      className={classNames(
        'selectable-button',
        classes.selectableButton,
        classes.card,
        {
          [classes.selectableButtonLarge]: useLargeCards,
          selected,
          'is-disabled': isDisabled,
        }
      )}
    >
      <div className={classNames(classes.contents, `${id}-card`)} >
        <input
          type="radio"
          id={`${id}-card-radio`}
          className="shared-radio"
          aria-checked={selected}
          checked={selected}
          onChange={onClickHandler}
          value={_.isString(description) ? description : descriptionValue}
          aria-setsize={ariaItemSize}
          aria-posinset={ariaItemIndex}
          tabIndex={0}
          aria-label={ariaLable}
          disabled={isDisabled}
          name={name}
        />
        { /* eslint-disable-next-line jsx-a11y/label-has-for */ }
        <label className="selectable-card-label" htmlFor={`${id}-card-radio`}>
          <div className={classNames('card-header', classes.cardHeader, useLargeCards ? classes.cardHeaderLarge : classes.cardHeaderSmall)}>
            {iconName && (
              <FontIcon iconName={iconName} className={classNames('header-icon', 'title-icon', classes.titleIcon, `${id}-icon-container`)} />
            )}
            {glyphIconName && (
              <Glyphicon className={classNames('header-icon', 'title-icon', classes.titleIcon, `${id}-icon-container`)} glyph={glyphIconName} />
            )}
            <p className={classNames('title', 'text', `${id}-text`, 'title-text', 'edit', classes.title)}>{title}</p>
          </div>
          <p className={classNames('description', classes.description)}>{description}</p>
          {footer && <p className={classNames('footer', classes.footer)}>{footer}</p>}
        </label>
      </div>
    </div>
  );
};

SelectableCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  footer: PropTypes.string,
  iconName: PropTypes.string,
  glyphIconName: PropTypes.string,
  isDisabled: PropTypes.bool,
  useLargeCards: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  onClickCard: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    card: PropTypes.string,
    cardHeader: PropTypes.string,
    cardHeaderLarge: PropTypes.string,
    cardHeaderSmall: PropTypes.string,
    contents: PropTypes.string,
    description: PropTypes.string,
    footer: PropTypes.string,
    selectableButton: PropTypes.string,
    selectableButtonLarge: PropTypes.string,
    selectableButtonSmall: PropTypes.string,
    title: PropTypes.string,
    titleIcon: PropTypes.string,
  }).isRequired,
  ariaItemSize: PropTypes.number.isRequired,
  ariaItemIndex: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  descriptionValue: PropTypes.string,
};

SelectableCard.defaultProps = {
  iconName: null,
  footer: null,
  glyphIconName: null,
  isDisabled: false,
  description: null,
  descriptionValue: '',
};
